module.exports = {
          srcSet: __webpack_public_path__ + "139a67f90e01a2b75b625f3aaf615f53-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "139a67f90e01a2b75b625f3aaf615f53-180.png",width: 180,height: 55}],
          src: __webpack_public_path__ + "139a67f90e01a2b75b625f3aaf615f53-180.png",
          toString:function(){return __webpack_public_path__ + "139a67f90e01a2b75b625f3aaf615f53-180.png"},
          
          width: 180,
          height: 55
        }